<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 10:17:48
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-17 09:34:24
-->
<template>
   <div>
    
        <a-drawer
          :title="id ? '编辑栏目' : '添加栏目'"
          :width="width<1440?'90%':width>1440 && width< 1800?'70%':'60%'"
          :visible="visible"
          :body-style="{ paddingBottom: '80px' }"
          @close="onClose"
        >
        <a-spin :spinning="detailShow">
          <a-spin :spinning="loadingBox" tip="数据处理中...">
            <div>
              <div class="type">
                <div class="log-box">
                  <div
                    @click="changeType(1)"
                    :style="{
                      color: type == 1 ? '#1890FF' : '',
                      borderBottom: type == 1 ? 'none' : '',
                    }"
                    class="log"
                  >
                    基本设置
                  </div>
                  <div
                    @click="changeType(2)"
                    :style="{
                      color: type == 2 ? '#1890FF' : '',
                      borderBottom: type == 2 ? 'none' : '',
                    }"
                    class="log"
                  >
                    SEO设置
                  </div>
                  <div
                    @click="changeType(3)"
                    :style="{
                      color: type == 3 ? '#1890FF' : '',
                      borderBottom: type == 3 ? 'none' : '',
                    }"
                    class="log"
                  >
                    内容设置
                  </div>
                  <div
                    @click="changeType(4)"
                    :style="{
                      color: type == 4 ? '#1890FF' : '',
                      borderBottom: type == 4 ? 'none' : '',
                    }"
                    class="log"
                  >
                    模板设置
                  </div>
                </div>
                <div class="dir"></div>
              </div>
              <div class="form">
                <el-form
                  :model="ruleForm"
                  :rules="rules"
                  ref="ruleForm"
                  label-width="100px"
                  :style="{ height: height }"
                  class="demo-ruleForm"
                >
                  <div v-show="type == 1">
                    <el-form
                      :rules="rules"
                      ref="ruleFormBase"
                      label-width="100px"
                      class="base_seting"
                      :model="ruleForm.columnBasicInfo"
                    >
                      <a-form-item style="width:100%" label="上级栏目" prop="parentId">
                        <a-tree-select
                          v-model="value"
                          style="width: 100%"
                          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                          :tree-data="resData"
                          placeholder="选择上级栏目"
                          :tree-default-expand-all="false"
                        >
                        </a-tree-select>
                      </a-form-item>
                      <el-form-item label="栏目类型" prop="columnType">
                        <div class="status">
                          <el-radio
                            v-model="ruleForm.columnBasicInfo.columnType"
                            label="0"
                            >本站栏目</el-radio
                          >
                          <el-radio
                            v-model="ruleForm.columnBasicInfo.columnType"
                            label="1"
                            >自定义链接</el-radio
                          >
                        </div>
                      </el-form-item>
                      <el-form-item
                        label="自定义链接"
                        prop="customUrl"
                        v-if="ruleForm.columnBasicInfo.columnType == 1"
                      >
                        <el-input
                          v-model="ruleForm.columnBasicInfo.customUrl"
                          placeholder="请输入自定义链接"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="栏目名称" prop="columnName">
                        <el-input
                          v-model="ruleForm.columnBasicInfo.columnName"
                          placeholder="请输入栏目名称"
                        ></el-input>
                        <div style="color: #ccc; font-size: 12px">
                          政府网站具体栏目名称，将同步设置为ColumnName
                        </div>
                      </el-form-item>
                      <el-form-item v-if="ruleForm.columnBasicInfo.columnType != 1" label="访问目录" prop="folder">
                        <el-input
                          placeholder="请输入栏目访问目录"
                          v-model="ruleForm.columnBasicInfo.folder"
                          :disabled="
                            ruleForm.columnBasicInfo.columnType == 1 ? true : false
                          "
                        >
                          <template slot="append"
                            ><span class="pasword">生成目录</span></template
                          >
                        </el-input>
                      </el-form-item>
                      <el-form-item v-if="ruleForm.columnBasicInfo.columnType == 1" label="访问目录">
                        <el-input
                          placeholder="请输入栏目访问目录"
                          v-model="ruleForm.columnBasicInfo.folder"
                          :disabled="
                            ruleForm.columnBasicInfo.columnType == 1 ? true : false
                          "
                        >
                          <template slot="append"
                            ><span class="pasword">生成目录</span></template
                          >
                        </el-input>
                      </el-form-item>
                      <el-form-item v-if="ruleForm.columnBasicInfo.columnType != 1" label="栏目关键词" prop="columnKeyword">
                        <el-input
                          v-model="ruleForm.columnBasicInfo.columnKeyword"
                          placeholder="请输入栏目关键词"
                          :disabled="
                            ruleForm.columnBasicInfo.columnType == 1 ? true : false
                          "
                        ></el-input>
                        <div style="color: #ccc; font-size: 12px">
                          可填写多个关键词，以英文逗号","隔开，将同步设置为ColumnKeywords
                        </div>
                      </el-form-item>
                      <el-form-item v-if="ruleForm.columnBasicInfo.columnType == 1" label="栏目关键词">
                        <el-input
                          v-model="ruleForm.columnBasicInfo.columnKeyword"
                          placeholder="请输入栏目关键词"
                          :disabled="
                            ruleForm.columnBasicInfo.columnType == 1 ? true : false
                          "
                        ></el-input>
                        <div style="color: #ccc; font-size: 12px">
                          可填写多个关键词，以英文逗号","隔开，将同步设置为ColumnKeywords
                        </div>
                      </el-form-item>
                      <el-form-item label="栏目类别" v-if="ruleForm.columnBasicInfo.columnType != 1" prop="columnCategory">
                        <el-input
                          v-model="ruleForm.columnBasicInfo.columnCategory"
                          placeholder="请输入栏目类别"
                          :disabled="
                            ruleForm.columnBasicInfo.columnType == 1 ? true : false
                          "
                        ></el-input>
                        <div style="color: #ccc; font-size: 12px">
                          政府网站具体栏目所属类别，将同步设置为ColumnType
                        </div>
                      </el-form-item>
                      <el-form-item label="栏目类别" v-if="ruleForm.columnBasicInfo.columnType == 1">
                        <el-input
                          v-model="ruleForm.columnBasicInfo.columnCategory"
                          placeholder="请输入栏目类别"
                          :disabled="
                            ruleForm.columnBasicInfo.columnType == 1 ? true : false
                          "
                        ></el-input>
                        <div style="color: #ccc; font-size: 12px">
                          政府网站具体栏目所属类别，将同步设置为ColumnType
                        </div>
                      </el-form-item>
                      <el-form-item v-if="ruleForm.columnBasicInfo.columnType != 1" label="栏目描述" prop="columnNote">
                        <el-input
                          type="textarea"
                          v-model="ruleForm.columnBasicInfo.columnNote"
                          placeholder="请输入栏目描述"
                          :disabled="
                            ruleForm.columnBasicInfo.columnType == 1 ? true : false
                          "
                        ></el-input>
                        <div style="color: #ccc; font-size: 12px">
                          政府网站具体栏目的主要内容说明，将同步设置为ColumnDescription
                        </div>
                      </el-form-item>
                      <el-form-item v-if="ruleForm.columnBasicInfo.columnType == 1" label="栏目描述">
                        <el-input
                          type="textarea"
                          v-model="ruleForm.columnBasicInfo.columnNote"
                          placeholder="请输入栏目描述"
                          :disabled="
                            ruleForm.columnBasicInfo.columnType == 1 ? true : false
                          "
                        ></el-input>
                        <div style="color: #ccc; font-size: 12px">
                          政府网站具体栏目的主要内容说明，将同步设置为ColumnDescription
                        </div>
                      </el-form-item>
                      <el-form-item label="打开方式" prop="openType">
                        <div class="status">
                          <el-radio
                            v-model="ruleForm.columnBasicInfo.openType"
                            label="0"
                            >本窗口打开</el-radio
                          >
                          <el-radio
                            v-model="ruleForm.columnBasicInfo.openType"
                            label="1"
                            >新窗口打开</el-radio
                          >
                        </div>
                      </el-form-item>
                      <el-form-item label="排序方式" prop="sortType">
                        <div class="status">
                          <el-radio
                            v-model="ruleForm.columnBasicInfo.sortType"
                            label="0"
                            >按时间排序</el-radio
                          >
                          <el-radio
                            v-model="ruleForm.columnBasicInfo.sortType"
                            label="1"
                            >按手动排序</el-radio
                          >
                        </div>
                         <div style="color: #ccc; font-size: 12px">
                         设置该栏目下的稿件列表以哪种方式进行排序
                        </div>
                      </el-form-item>
                      <el-form-item label="是否导航" prop="isNavigation">
                        <div class="status">
                          <el-radio
                            v-model="ruleForm.columnBasicInfo.isNavigation"
                            label="0"
                            >是</el-radio
                          >
                          <el-radio
                            v-model="ruleForm.columnBasicInfo.isNavigation"
                            label="1"
                            >否</el-radio
                          >
                        </div>
                         <div style="color: #ccc; font-size: 12px">
                         该栏目是否为父级栏目下的导航栏目
                        </div>
                      </el-form-item>
                      <el-form-item label="稿件引用">
                        <el-input
                          placeholder="未设置"
                          disabled
                          v-model="gaojianvalue"
                        >
                          <template slot="append">
                            <span
                              v-if="!gaojianvalue"
                              @click="selectColumn"
                              style="cursor: pointer"
                              class="pasword"
                              >选择栏目</span
                            >
                            <span
                              v-if="gaojianvalue"
                              @click="quxiaoColumn"
                              style="cursor: pointer"
                              class="pasword"
                              >取消引用</span
                            >
                          </template>
                        </el-input>
                         <div style="color: #ccc; font-size: 12px">
                          设置引用后，被引用栏目稿件将同步至本栏目下
                        </div>
                      </el-form-item>
                        <el-form-item label="稿件推送">
                        <el-input
                          placeholder="未设置"
                          disabled
                          v-model="gaojianvalueTwo"
                        >
                          <template slot="append">
                            <span
                              v-if="!gaojianvalueTwo"
                              @click="selectColumnTwo"
                              style="cursor: pointer"
                              class="pasword"
                              >选择栏目</span
                            >
                            <span
                              v-if="gaojianvalueTwo"
                              @click="quxiaoColumnTwo"
                              style="cursor: pointer"
                              class="pasword"
                              >取消推送</span
                            >
                          </template>
                        </el-input>
                          <div style="color: #ccc; font-size: 12px">
                          设置后，本栏目下发布稿件将自动推送至目标栏目
                        </div>
                      </el-form-item>
                       <el-form-item label="推送审核" prop="flagAudit">
                        <div class="status">
                          <el-radio
                            v-model="ruleForm.columnBasicInfo.flagAudit"
                            :label="1"
                            >需要审核(有评分)</el-radio
                          >
                          <el-radio
                            v-model="ruleForm.columnBasicInfo.flagAudit"
                            :label="2"
                            >无需审核(无评分)</el-radio
                          >
                        </div>
                         <div style="color: #ccc; font-size: 12px">
                         无需审核时，稿件在本栏目发布后将跳过采纳环节直接推送至目标栏目并发布
                        </div>
                      </el-form-item>
                      <el-form-item v-if="ruleForm.columnBasicInfo.columnType != 1" label="自动归档" prop="isAutomaticArchive">
                        <div class="status">
                          <el-radio
                            v-model="ruleForm.columnBasicInfo.isAutomaticArchive"
                            label="0"
                            :disabled="
                              ruleForm.columnBasicInfo.columnType == 1 ? true : false
                            "
                            >启用</el-radio
                          >
                          <el-radio
                            v-model="ruleForm.columnBasicInfo.isAutomaticArchive"
                            label="1"
                            :disabled="
                              ruleForm.columnBasicInfo.columnType == 1 ? true : false
                            "
                            >停用</el-radio
                          >
                        </div>
                      </el-form-item>
                      <el-form-item v-if="ruleForm.columnBasicInfo.columnType == 1" label="自动归档" prop="isAutomaticArchive">
                        <div class="status">
                          <el-radio
                            v-model="ruleForm.columnBasicInfo.isAutomaticArchive"
                            label="0"
                            :disabled="
                              ruleForm.columnBasicInfo.columnType == 1 ? true : false
                            "
                            >启用</el-radio
                          >
                          <el-radio
                            v-model="ruleForm.columnBasicInfo.isAutomaticArchive"
                            label="1"
                            :disabled="
                              ruleForm.columnBasicInfo.columnType == 1 ? true : false
                            "
                            >停用</el-radio
                          >
                        </div>
                      </el-form-item>
                      <el-form-item v-if="ruleForm.columnBasicInfo.columnType != 1" label="归档时间" prop="automaticArchiveTime" :required="ruleForm.columnBasicInfo.isAutomaticArchive==='0'">
                        <el-date-picker
                          :disabled="
                            ruleForm.columnBasicInfo.columnType == 1 ? true : false
                          "
                          v-model="ruleForm.columnBasicInfo.automaticArchiveTime"
                          type="datetime"
                          style="width: 100%"
                          placeholder="设置归档时间"
                        >
                        </el-date-picker>
                      </el-form-item>
                      <el-form-item v-if="ruleForm.columnBasicInfo.columnType == 1" label="归档时间" prop="automaticArchiveTime" :required="ruleForm.columnBasicInfo.isAutomaticArchive==='0'">
                        <el-date-picker
                          :disabled="
                            ruleForm.columnBasicInfo.columnType == 1 ? true : false
                          "
                          v-model="ruleForm.columnBasicInfo.automaticArchiveTime"
                          type="datetime"
                          style="width: 100%"
                          placeholder="设置归档时间"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-form>
                  </div>
                  <div v-if="type == 2">
                    <el-form-item label="SEO标题">
                      <el-input
                        v-model="ruleForm.columnSeoInfo.seoTitle"
                        placeholder="请输入SEO标题"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="SEO关键字">
                      <el-input
                        v-model="ruleForm.columnSeoInfo.seoKeyword"
                        placeholder="请输入SEO关键字"
                      ></el-input>
                      <div style="color: #ccc; font-size: 12px">
                        可填写多个关键字，以英文逗号","隔开
                      </div>
                    </el-form-item>
                    <el-form-item label="SEO描述">
                      <el-input
                        type="textarea"
                        v-model="ruleForm.columnSeoInfo.seoNote"
                        placeholder="请输入SEO描述描述"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div v-show="type == 3">
                    <div class="cont-setting">
                      <el-form-item label="图片上传">
                        <a-upload
                          name="avatar"
                          list-type="picture-card"
                          class="avatar-uploader"
                          :show-upload-list="false"
                          :before-upload="beforeUpload"
                        >
                          <img
                            style="width: 100%; max-height: 100%"
                            v-if="imageUrl"
                            :src="imgIp + imageUrl"
                            alt="avatar"
                          />
                          <div v-else>
                            <a-icon :type="loading ? 'loading' : 'plus'" />
                            <div class="ant-upload-text">上传图片</div>
                          </div>
                        </a-upload>
                      </el-form-item>

                      <el-form-item label="富文本">
                        <uEditorWrap
                          v-model="ruleForm.columnContentInfo.richText"
                          @ready="ueditorReady"
                          editor-id="editor"
                          :config="uEditorConfig"
                          :editorDependencies="[
                            'ueditor.config.js',
                            'ueditor.all.js',
                          ]"
                          style="min-height: 220px;width:640px"
                        />
                        <!--                <Toolbar-->
                        <!--                  :editor="editor"-->
                        <!--                  :defaultConfig="toolbarConfig"-->
                        <!--                  :mode="mode"-->
                        <!--                  style="width: 800px; border: solid #f4f4f6 2px"-->
                        <!--                />-->
                        <!--                <Editor-->
                        <!--                  style="-->
                        <!--                    width: 800px;-->
                        <!--                    height: 290px;-->
                        <!--                    overflow-y: hidden;-->
                        <!--                    padding: 10px;-->
                        <!--                    border: solid #f4f4f6 2px;-->
                        <!--                  "-->
                        <!--                  v-model="ruleForm.columnContentInfo.richText"-->
                        <!--                  :defaultConfig="editorConfig"-->
                        <!--                   :defaultContent="jsonContent"-->
                        <!--                  :mode="mode"-->
                        <!--                  @onCreated="onCreated"-->
                        <!--                />-->
                        <!-- <editor :richText="richText" @changeText="changeText"></editor> -->
                      </el-form-item>
                    </div>
                  </div>
                  <div v-if="type == 4">
                    <el-form-item label="栏目模板">
                      <el-input
                        class="change-model"
                        placeholder="栏目的模板文件"
                        v-model="ruleForm.columnTemplateInfo.columnTemplate"
                        disabled
                      >
                        <template slot="append">
                          <span @click="chooseTemplate(1)" style="cursor: pointer;" class="pasword"
                            >选择模板</span
                          >
                        </template>
                      </el-input>
                      <el-button @click="deleteTemplate" class="delete-btn"
                        >删除模板</el-button
                      >
                      <div style="color: #ccc; font-size: 12px">
                        设置栏目页面的模板文件，栏目类型为自定义链接时无效
                      </div>
                    </el-form-item>
                    <el-form-item label="内容模型">
                      <el-select
                        multiple
                        v-model="ruleForm.columnTemplateInfo.contentModeIds"
                        style="width: 100%"
                        placeholder="请选择"
                      >
                        <el-option
                          :key="index"
                          v-for="(item, index) in listPageData"
                          :label="item.modelName"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="模板策略" prop="isNavigation">
                      <div class="status">
                        <el-radio
                          v-model="ruleForm.columnTemplateInfo.templateStrategy"
                          label="0"
                          >响应栏目模板</el-radio
                        >
                        <el-radio
                          v-model="ruleForm.columnTemplateInfo.templateStrategy"
                          label="1"
                          >响应内容模型模板</el-radio
                        >
                      </div>
                    </el-form-item>
                    <el-form-item
                      label="响应栏目模板"
                      v-if="ruleForm.columnTemplateInfo.templateStrategy == '0'"
                    >
                      <el-input
                        placeholder="响应栏目模板文件"
                        v-model="ruleForm.columnTemplateInfo.manuscriptInfoTemplate"
                        disabled
                      >
                        <template slot="append"
                          ><span @click="chooseTemplate(2)" style="cursor: pointer;" class="pasword"
                            >选择模板</span
                          ></template
                        >
                      </el-input>
                    </el-form-item>
                  </div>
                  
                </el-form>
                <!-- 选择模板 -->
                <!-- <div v-show="type != 1">
                      
                  </div>
                   <div v-show="type == 1">
                       <el-button style="margin-left:24px"  class="btn-box" size="medium" type="primary" @click="submit" :loading="loadingBtn"
                      >保存</el-button
                    >
                  </div> -->
                   <el-button  class="btn-box" size="medium" type="primary" @click="submit" :loading="loadingBtn"
                      >保存</el-button
                    >
              </div>
            </div>
          </a-spin>
        </a-spin>
      </a-drawer>     
  <div class="choose_template">
            <el-dialog width="700px" title="选择模板" :visible.sync="templateIsShow">
              <div class="lod-tips">
                <div class="lod-box">
                  <span>I</span>
                  模板只能选择.csshtml后缀的文件，点击文件夹图标可进入下级目录
                </div>
              </div>
              <div class="choose-path">
                <span
                  @click="returnParent(templateList.directoryPath)"
                  class="icon-arrow-back back-box"
                ></span>
                /{{ templateList.directoryPath }}
              </div>
              <div class="template-list">
                <div class="title item">名称</div>
                 <div class="list-box">
                    <div
                  class="item"
                  v-for="(
                    item, index
                  ) in templateList.templateDirectoryAndFileResponse"
                  :key="index"
                  @click="getTemplates(item.isDir, item.name, item.allPath, 2)"
                >
                  {{ item.name }}
                </div>
                 </div>
              </div>
            </el-dialog>
          </div>
          <el-dialog
            title="选择栏目"
            :visible.sync="dialogVisibleColumTwo"
            v-if="dialogVisibleColumTwo"
            width="600px"
            class="column-box"
            :before-close="handleCloseColumTwo"
            top="12%"
          >
            <div class="colum-title-box">
              <i style="margin-right: 8px" class="el-icon-info"></i
              >仅可选择一个栏目，引用后将同步该栏目稿件至本栏目
            </div>
             <a-spin  :spinning="loadingShow">
            <div class="tree-box">
              <a-tree
                v-if="resData.length"
                :checkable="true"
                v-model="checkedSiteId"
                :checkStrictly="true"
                :tree-data="resDataTwo"
                :load-data="onLoadData"
                ref="treeForm"
                @check="handleNodeClick"
              >
              </a-tree>
            </div>
             </a-spin>
            <span slot="footer" class="dialog-footer">
              <el-button @click="()=>{
                    this.dialogVisibleColumTwo = false;
                    this.loadingShow = false;
                 }"
                >取 消</el-button
              >
              <el-button
                :loading="loadingBtn"
                type="primary"
                @click="selectSave"
                >确定</el-button
              >
            </span>
          </el-dialog>
           <el-dialog
            title="选择栏目"
            :visible.sync="dialogVisibleColumTwoPush"
            v-if="dialogVisibleColumTwoPush"
            width="600px"
            class="column-box"
            :before-close="handleCloseColumTwoPush"
            top="12%"
          >
            <div class="colum-title-box">
              <i style="margin-right: 8px" class="el-icon-info"></i
              >仅可选择一个栏目，本栏目发布稿件将自动同步至选择的栏目
            </div>
             <a-spin  :spinning="loadingShow">
            <div class="tree-box">
                   <a-tree
                    :checkable="true"
                    v-model="checkedSiteIdTwo"
                    :checkStrictly="true"
                    :tree-data="resDataTwo"
                    :load-data="onLoadData"
                    ref="treeForm"
                    @check="handleNodeClickTwo"
                  >
                  </a-tree>
            </div>
             </a-spin>
            <span slot="footer" class="dialog-footer">
              <el-button @click="()=>{
                    this.dialogVisibleColumTwoPush = false;
                    this.loadingShow = false;
                }"
                >取 消</el-button
              >
              <el-button
                :loading="loadingBtn"
                type="primary"
                @click="selectSaveTwo"
                >确定</el-button
              >
            </span>
          </el-dialog>
   </div>
</template>

<script>
// import editor from "./editer.vue";
// import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import uEditorWrap from "vue-ueditor-wrap";
import {
  getTemplateList,
  addColumn,
  tree,
  listPage,
  detail,
  importColumnByPidList,
} from "./column_management";
import { uploadImg, uploadVideo } from "@/utils/common.js";
import { message } from "ant-design-vue";
import _ from 'lodash';
export default {
  data() {
    let self = this;
    return {
      uEditorConfig: {
        // 配置UEditorPlus的惊天资源
        UEDITOR_HOME_URL: process.env.VUE_APP_Admin || "/admin/static/uEditor/",
        UEDITOR_CORS_URL: process.env.VUE_APP_Admin || "/admin/static/uEditor/",
        // 服务器统一请求接口路径
        serverUrl:
          process.env.VUE_APP_BASE_URL + "/site-service/m/cover/uploadImage",
        // 启用拖放上传
        enableDragUpload: true,
        // 启用粘贴上传
        enablePasteUpload: true,
        // 启用图片拉伸缩放
        imageScaleEnabled: true,
      },
      loadServe: null,
      editor: null,
      dialogVisibleColumTwoPush:false,
      selectedKeys: [],
      expandedKeys: [],
      checkedKeys: [],
      loadingBtn: false,
      dialogVisibleColumTwo: false,
      toolbarConfig: {
        excludeKeys: ["todo", "emotion"],
      },
      editorConfig: {
        hoverbarKeys: {
          attachment: {
            menuKeys: ["downloadAttachment"], // “下载附件”菜单
          },
        },
        MENU_CONF: {
          uploadAttachment: {
            // 用户自定义上传
            customUpload(file, insertFn) {
              self.loadingBox = true;
              uploadImg(file, "fujian").then((res) => {
                self.loadingBox = false;
                var encodedData = window.btoa(
                  process.env.VUE_APP_Img_Ip + res.path
                ); // 编码
                let url = `${process.env.VUE_APP_Preview}?url=` + encodedData;
                insertFn(`${file.name}`, url);
              });
            },
          },
          fontFamily: {
            fontFamilyList: [
              "仿宋_GB2312",
              "黑体",
              "仿宋",
              "楷体",
              "标楷体",
              "华文仿宋",
              "华文楷体",
              "宋体",
              "微软雅黑",
              "Arial",
              "Tahoma",
              "Verdana",
              "Times New Roman",
              "Courier New",
            ],
          },
          uploadImage: {
            server: `${process.env.VUE_APP_BASE_URL}/site-service/m/cover/uploadImage`,
            fieldName: "file",
            meta: {
              type: "img",
            },
            headers: {
              token: sessionStorage.getItem("token"),
            },
            customInsert: this.customInsert,
            onProgress(progress) {
              // TS 语法
              self.loadingBox = true;
            },
            onSuccess(file, res) {
              // TS 语法
              self.loadingBox = false;
            },
            onFailed(file, res) {
              self.loadingBox = false;
            },
          },
          fontSize: {
            fontSizeList: [
              { name: "初号", value: "56px" },
              { name: "小初", value: "48px" },
              { name: "一号", value: "34px" },
              { name: "小一", value: "32px" },
              { name: "二号", value: "29px" },
              { name: "小二", value: "24px" },
              { name: "三号", value: "21px" },
              { name: "小三", value: "20px" },
              { name: "四号", value: "18px" },
              { name: "小四", value: "16px" },
              { name: "五号", value: "14px" },
              { name: "小五", value: "12px" },
            ],
          },
          lineHeight: {
            lineHeightList: ["1", "1.5", "2", "2.5", "3"],
          },
          // uploadVideo: {
          //   server:
          //     `${process.env.VUE_APP_BASE_URL}/site-service/m/cover/uploadImage`,
          //   fieldName: "file",
          //   meta: {
          //     type: "video",
          //   },
          //   maxFileSize:100* 1024 * 1024 * 1024,
          //   timeout: 60 * 60 * 1000,
          //   // 上传错误，或者触发 timeout 超时
          //   onError(file, err, res) {  // TS 语法
          //   // onError(file, err, res) {               // JS 语法
          //       console.log(`${file.name} 上传出错`, err, res)
          //   },
          //   // 单个文件上传成功之后
          //   onSuccess(file, res) {  // TS 语法
          //       console.log(`${file.name} 上传成功`, res)
          //       self.loadingBox = false;
          //   },
          //   onBeforeUpload(file) {   // TS 语法
          //         return file
          //     },
          //      onProgress(progress) {  // TS 语法
          //        self.loadingBox = true;
          //     },
          //   headers: {
          //     token: sessionStorage.getItem("token"),
          //   },
          //   customInsert: this.customInsert,
          // },
          uploadVideo: {
            maxFileSize: 100 * 1024 * 1024 * 1024,
            timeout: 60 * 60 * 1000,
            customUpload(file, insertFn) {
              // TS 语法
              self.loadingBox = true;
              uploadVideo(file, "video").then((res) => {
                if (res.video.path) {
                  self.loadingBox = false;
                  insertFn(
                    self.imgIp + res.video.path,
                    self.imgIp + res.image.path
                  );
                }
              });
            },
          },
        },
      },
      mode: "default", // or 'simple'
      title: "",
      createTime: new Date(),
      type: 1,
      templateIsShow: false,
      templateList: {},
      jsonContent: [
        {
          type: "paragraph",
          lineHeight: "1.5",
          children: [{ text: "", fontFamily: "宋体", fontSize: "18px" }],
        },
      ],
      resData: [],
      options: [],
      loadingBox: false,
      ruleForm: {
        columnBasicInfo: {
          parentId: "",
          columnType: "",
          columnName: "",
          folder: "",
          columnKeyword: "",
          columnCategory: "",
          columnNote: "",
          openType: "",
          sortType: "",
          isNavigation: "",
          isAutomaticArchive: "",
          flagAudit:1,
        },
        columnSeoInfo: {
          seoNote: "",
          seoKeyword: "",
          seoTitle: "",
        },
        columnContentInfo: {
          img: "",
          richText: "",
        },
        columnTemplateInfo: {
          columnTemplate: "",
          contentModeIds: [],
          templateStrategy: "",
          manuscriptInfoTemplate: "",
        },
      },
      checkedSiteId: [],
      checkedSiteIdTwo:[],
      resDataTwo: [],
      rules: {
        parentId: [
          { required: true, message: "请选择上级栏目", trigger: "blur" },
        ],
        columnType: [
          { required: true, message: "请选择栏目类型", trigger: "blur" },
        ],
        columnName: [
          { required: true, message: "请输入栏目名称", trigger: "blur" },
        ],
        folder: [
          { required: true, message: "请输入栏目访问目录", trigger: "blur" },
        ],
        columnKeyword: [
          { required: true, message: "请输入栏目关键词", trigger: "blur" },
        ],
        columnCategory: [
          { required: true, message: "请输入栏目类别", trigger: "blur" },
        ],
        columnNote: [
          { required: true, message: "请输入栏目描述", trigger: "blur" },
        ],
        openType: [
          { required: true, message: "请选择打开方式", trigger: "blur" },
        ],
        sortType: [
          { required: true, message: "请选择排序方式", trigger: "blur" },
        ],
        isNavigation: [
          { required: true, message: "请选择是否导航", trigger: "blur" },
        ],
        isAutomaticArchive: [
          { required: true, message: "请选择是否自动归档", trigger: "blur" },
        ],
      },
      isFile: 1,
      id: "",
      listPageData: [],
      richText: "",
      file: "",
      loading: false,
      imageUrl: "",
      chooseTemplateType: 1,
      value: null,
      height: 0,
      result: [],
      resultTwo:[],
      gaojianvalue: "",
      gaojianvalueTwo: "",
      gaoType:'',
      loadingShow:false,
      detailShow:false,
      width:'',
    };
  },
  components: {
    // Editor, Toolbar
    uEditorWrap,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    itemId: {
      default: "",
    },
    columnId:{
      default: null,
    }
  },
  mounted() {
    
  },
  watch: {
    visible(val) {
      if (val) {
        this.type = 1;
        this.getPage();
        this.id = this.itemId;
        this.value = this.columnId;
        this.imageUrl = '';
        if (this.id) {
            this.getDetail();
        }else{
          this.ruleForm = {
            columnBasicInfo: {
              parentId: "",
              columnType: "",
              columnName: "",
              folder: "",
              columnKeyword: "",
              columnCategory: "",
              columnNote: "",
              openType: "",
              sortType: "",
              isNavigation: "",
              isAutomaticArchive: "",
              flagAudit:1,
            },
            columnSeoInfo: {
              seoNote: "",
              seoKeyword: "",
              seoTitle: "",
            },
            columnContentInfo: {
              img: "",
              richText: "",
            },
            columnTemplateInfo: {
              columnTemplate: "",
              contentModeIds: [],
              templateStrategy: "",
              manuscriptInfoTemplate: "",
            },
          };
          this.gaojianvalue = "";
          this.gaojianvalueTwo = "";
          this.ruleForm.columnBasicInfo.importColumnId = ""
          this.ruleForm.columnBasicInfo.pushColumnId = ""
          this.getList();
        }
        this.height = document.documentElement.clientHeight - 390 + "px";
        this.width  = document.documentElement.clientWidth;
        window.onresize = () => {
          return (() => {
            this.height = document.documentElement.clientHeight - 390 + "px";
             this.width  = document.documentElement.clientWidth;
          })();
        };
      }
    },
    ruleForm:{
      handler:function (newVal,oldVal){
        if(newVal.columnBasicInfo.isAutomaticArchive==='0'){
          this.rules.automaticArchiveTime = [
            { required: true, message: "请选择归档时间", trigger: "blur" }
          ]
        }else if(newVal.columnBasicInfo.isAutomaticArchive==='1'){
          delete this.rules.automaticArchiveTime;
        }
      },
      deep:true
    }
  },
  methods: {
    onLoadData(treeNode){
       return new Promise((resolve) => {
        if(treeNode.dataRef.hasChildren){
            importColumnByPidList({
                  id:treeNode.dataRef.key,
                }).then((res) => {
                  if (res.code == 0) {
                      let optionsTwo = JSON.stringify(res.data)
                      .replace(/columnName/g, "title")
                      .replace(/id/g, "key");
                      let  resDataTwo = JSON.parse(optionsTwo);
                      treeNode.dataRef.children  = this.disFn(resDataTwo);
                      this.resDataTwo = [...this.resDataTwo];
                      resolve(this.resDataTwo);
                  }
                });
              }else{
                resolve(this.resDataTwo);
              }
          });
    },
    handleCloseColumTwoPush(){
        this.dialogVisibleColumTwoPush = false;
    },
    onClose() {
      this.$emit("onClose",this.value);
    },
    ueditorReady(editor) {
      this.editor = editor;
      // this.editor.setContent(this.txtUpdate);
      //editor.placeholder('<span style="color:#999">正文</span>');
      this.editor.addListener("fullscreenchanged", function (t, enabled) {
        if (!enabled) {
          editor.unsetFloating();
        }else{
          document.getElementsByClassName("edui-editor-iframeholder")[0].style.maxHeight="100vh";
          document.getElementsByTagName("iframe")[0].style.maxHeight="100vh";
        }
      });
    },

    /**
     * 节点选中状态发生变化时的回调
     * */
    selectSave() {
      this.gaojianvalue = this.result;
      this.dialogVisibleColumTwo = false;
    },
    selectSaveTwo(){
      this.gaojianvalueTwo = this.resultTwo;
      this.dialogVisibleColumTwoPush = false;
    },
    quxiaoColumn() {
      this.result = [];
      this.checkedSiteId = [];
      this.gaojianvalue = "";
      this.ruleForm.columnBasicInfo.importColumnId = "";
    },
    quxiaoColumnTwo() {
      this.resultTwo = [];
      this.checkedSiteIdTwo = [];
      this.gaojianvalueTwo = "";
      this.ruleForm.columnBasicInfo.pushColumnId = "";
    },
    handleNodeClick(checkedKeys) {
      this.checkedSiteId = [].concat(
        checkedKeys.checked[checkedKeys.checked.length - 1]
      );
      this.ruleForm.columnBasicInfo.importColumnId = this.checkedSiteId[0];
      let result = JSON.parse(
        JSON.stringify(this.find(this.resDataTwo, this.checkedSiteId, []))
      );
      result.map((item) => {
        let res = this.setColumnName(
          this.resDataTwo,
          (data) => data.key === item.key
        ); //所有父级名称
        item.title = res.join(">");
        this.result = res.join("/");
      });
    },
    handleNodeClickTwo(checkedKeys) {
      this.checkedSiteIdTwo = [].concat(
        checkedKeys.checked[checkedKeys.checked.length - 1]
      );
      this.ruleForm.columnBasicInfo.pushColumnId = this.checkedSiteIdTwo[0];
      let result = JSON.parse(
        JSON.stringify(this.find(this.resDataTwo, this.checkedSiteIdTwo, []))
      );
      result.map((item) => {
        let res = this.setColumnName(
          this.resDataTwo,
          (data) => data.key === item.key
        ); //所有父级名称
        item.title = res.join(">");
        this.resultTwo = res.join("/");
      });
    },
    find(arr, keys, selectArr) {
      arr.forEach((element) => {
        if (element.children) {
          if (keys.indexOf(element.key) != -1) {
            selectArr.push(element);
          }
          this.find(element.children, keys, selectArr);
        } else {
          if (keys.indexOf(element.key) != -1) {
            selectArr.push(element);
          }
        }
      });
      return selectArr;
    },
    setColumnName(tree, func, res = []) {
      const _this = this;
      if (!tree) return;
      for (const data of tree) {
        res.push(data.title);
        if (func(data)) return res;
        if (data.children) {
          const findChildren = _this.setColumnName(data.children, func, res);
          if (findChildren.length) return findChildren;
        }
        res.pop();
      }
      return [];
    },

    onExpand(expandedKeys) {
      console.log("onExpand", expandedKeys);
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    onSelect(selectedKeys, info) {
      this.selectedKeys = selectedKeys;
    },
    selectColumn() {
      this.dialogVisibleColumTwo = true;
      this.loadingShow = true;
      this.resDataTwo = JSON.parse(JSON.stringify([]))
      importColumnByPidList({
        id:0,
      }).then((res) => {
        if (res.code == 0) {
            let optionsTwo = JSON.stringify(res.data)
            .replace(/columnName/g, "title")
            .replace(/id/g, "key");
            this.resDataTwo = JSON.parse(optionsTwo);
            this.resDataTwo = this.disFn(this.resDataTwo);
            this.loadingShow = false;
        }
      });
    },
    selectColumnTwo() {
      this.dialogVisibleColumTwoPush = true;
      this.loadingShow = true;
      this.resDataTwo = JSON.parse(JSON.stringify([]))
      importColumnByPidList({
        id:0,
      }).then((res) => {
        if (res.code == 0) {
            let optionsTwo = JSON.stringify(res.data)
            .replace(/columnName/g, "title")
            .replace(/id/g, "key");
            this.resDataTwo = JSON.parse(optionsTwo);
            this.resDataTwo = this.disFn(this.resDataTwo);
            this.loadingShow = false;
        }
      });
    },
    handleCloseColumTwo() {
      this.dialogVisibleColumTwo = false;
    },
    customInsert(res, insertFn) {
      let url = this.imgIp + res.data.path;
      let alt = res.data.name;
      insertFn(url, alt, "");
    },
    toBack() {},
    // onCreated(editor) {
    //   let a = (this.editor = Object.seal(editor)); // 一定要用 Object.seal() ，否则会报错
    // },
    async beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
      }
      this.loading = true;
      let imgData = await uploadImg(file, "column_management");
      this.imageUrl = imgData.path;
      this.loading = false;
      return false;
    },
    getDetail() {
      this.detailShow = true;
      detail({
        id: this.id,
      }).then((res) => {
        if (res.code == 0) {
          this.ruleForm.columnBasicInfo = res.data.columnBasicInfo;
          this.ruleForm.columnContentInfo = res.data.columnContentInfo;
          this.ruleForm.columnSeoInfo = res.data.columnSeoInfo;
          this.ruleForm.columnTemplateInfo = res.data.columnTemplateInfo;
          this.ruleForm.columnBasicInfo.columnType = `${res.data.columnBasicInfo.columnType}`;
          this.ruleForm.columnBasicInfo.isAutomaticArchive = `${res.data.columnBasicInfo.isAutomaticArchive}`;
          this.ruleForm.columnBasicInfo.isNavigation = `${res.data.columnBasicInfo.isNavigation}`;
          this.ruleForm.columnBasicInfo.openType = `${res.data.columnBasicInfo.openType}`;
          this.ruleForm.columnBasicInfo.sortType = `${res.data.columnBasicInfo.sortType}`;
          this.checkedSiteId = [res.data.columnBasicInfo.importColumnId];
          this.checkedSiteIdTwo = [res.data.columnBasicInfo.pushColumnId];
          this.gaojianvalue = res.data.columnBasicInfo.importColumnName;
          this.gaojianvalueTwo = res.data.columnBasicInfo.pushColumnName;
          this.value = res.data.columnBasicInfo.parentId || null;
          //this.ruleForm.columnBasicInfo.parentId = res.data.columnBasicInfo.parentId
          this.ruleForm.columnTemplateInfo.templateStrategy = `${res.data.columnTemplateInfo.templateStrategy}`;
          this.richText = res.data.columnContentInfo.richText;
          this.imageUrl = res.data.columnContentInfo.img;
          this.ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
          this.getList();
        }
      });
    },
    changeText(val) {
      this.ruleForm.columnContentInfo.richText = val;
    },
    getPage() {
      listPage({
        current: 1,
        size: 100000000,
        siteId: sessionStorage.getItem("siteId"),
      }).then((res) => {
        if (res.code == 0) {
          this.listPageData = JSON.parse(JSON.stringify(res.data.records));
        }
      });
    },
    getList() {
      let _this = this;
      this.detailShow = true;
      tree({
        siteId: sessionStorage.getItem("siteId"),
      }).then((res) => {
        if (res.code == 0) {
          let options = JSON.stringify(res.data)
            .replace(/columnName/g, "title")
            .replace(/id/g, "value");
          _this.resData = JSON.parse(options);
          this.detailShow = false;
        }
      });
    },
    disFn(data){
            for (let index = 0; index < data.length; index++) {
                if(data[index].hasChildren){
                    data[index].isLeaf = false;
                }else{
                    data[index].isLeaf = true;
                }
                if(data[index].key == this.id){
                     data[index].disabled = true;
                }else{
                  if(data[index].children){
                      this.disFn(data[index].children)
                  }
                }
            }
            return data;
        },
    submit: _.debounce(function () {
       if (this.editor) {
        this.editor.focus(true);
      }
      setTimeout(() => {
        this.loadingBtn = true;
        this.ruleForm.columnBasicInfo.parentId = this.value ? this.value : 0;
        this.$refs.ruleFormBase.validate((valid) => {
          if (valid) {
            this.ruleForm.columnContentInfo.img = this.imageUrl;
            this.ruleForm.columnBasicInfo.automaticArchiveTime = this.ruleForm
              .columnBasicInfo.automaticArchiveTime
              ? this.farmatDate(
                  this.ruleForm.columnBasicInfo.automaticArchiveTime,
                  "-"
                )
              : "";
            addColumn({
              ...this.ruleForm,
              siteId: sessionStorage.getItem("siteId"),
              id: this.id,
            }).then((res) => {
              if (res.code == 0) {
                this.id = res.data.id;
                this.$emit('parentIdFn',this.ruleForm.columnBasicInfo.parentId)
                message.success(res.msg);
              }
              this.loadingBtn = false;
            });
          } else {
            this.loadingBtn = false;
            this.changeType(1);
          }
        });
      }, 200);
    }, 1000),
    changeType(type) {
      this.type = type;
    },
    backPage() {
      this.$router.push({
        path: "/index/configure/column_management",
      });
    },
    returnParent(directoryPath) {
      let path = directoryPath.substring(
        0,
        directoryPath.lastIndexOf("/", directoryPath.lastIndexOf("/") - 1) + 1
      );
      if (path) {
        this.getTemplates(true, "", path, 2);
      }
    },
    // 选择模板
    chooseTemplate(type) {
      const _this = this;
      _this.chooseTemplateType = type;
      _this.templateIsShow = true;
      console.log(_this.templateIsShow);
      _this.getTemplates(true);
    },
    getTemplates(isDir, fileName = "", path = "", type) {
      const _this = this;
      if (isDir) {
        let reqData = {
          fileName: fileName,
          path: path,
          siteId: sessionStorage.getItem("siteId"),
          type: type ? type : 1,
          isHtml: true,
        };
        getTemplateList(reqData).then((res) => {
          if (res.code == 0) {
            _this.templateList = res.data;
          }
        });
      } else {
        console.log(path);
        let allPath = path.substring(path.indexOf("/") + 1, path.length);
        console.log(allPath);
        if (_this.chooseTemplateType == 1) {
          _this.ruleForm.columnTemplateInfo.columnTemplate = allPath;
        } else {
          _this.ruleForm.columnTemplateInfo.manuscriptInfoTemplate = allPath;
        }
        _this.templateIsShow = false;
      }
    },
    farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
    deleteTemplate() {
      console.log(222);
      this.ruleForm.columnTemplateInfo.columnTemplate = "";
    },
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>
.top {
  width: 100%;
  padding: 24px;
  border-bottom: solid #f4f4f6 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .search {
    display: flex;
  }
  .back {
    font-size: 18px;
    font-weight: 600;
    color: #000;
  }
  .add-img {
    margin-right: 5px;
    margin-top: -3px;
    cursor: pointer;
  }
}
.log-box {
  //border-bottom: solid 1px #dcdfe6;
  display: flex;
  margin-left: 24px;
  margin-right: 24px;
  margin-top: 24px;
  .log {
    padding: 10px 20px;
    border-top: solid 1px #dcdfe6;
    border-left: solid 1px #dcdfe6;
    cursor: pointer;
    border-bottom: solid 1px #dcdfe6;
  }
  .log:last-child {
    border-right: solid 1px #dcdfe6;
    border-top-right-radius: 10px;
  }
  .log:first-child {
    border-top-left-radius: 10px;
  }
}
.dir {
  height: 1px;
  background: #dcdfe6;
  margin-left: 409px;
  margin-right: 24px;
  margin-top: -1px;
}
.form {
  width: 70%;
  margin-top: 60px;
}
.status {
  border: solid 1px #dcdfe6;
  border-radius: 4px;
  padding-left: 10px;
}
/deep/ .el-radio__inner::after {
  width: 8px;
  height: 8px;
}
/deep/ .el-radio__inner {
  width: 16px;
  height: 16px;
}
/deep/ .ant-select-selection--single {
  height: 44px;
}
/deep/ .ant-select-selection__rendered {
  line-height: 44px;
}
.choose_template {
  /deep/.el-dialog__title {
    font-size: 18px;
    font-weight: bold;
  }
  /deep/ .el-dialog__body{
            padding-top:10px;
        }
        /deep/ .el-dialog__close{
            font-weight: 600;
        }
  /deep/.el-dialog {
    width: 36%;
  }
  .lod-tips {
    background: #f7f7f7;
    font-size: 12px;
    color: #928f8f;
    line-height: 36px;
    padding: 0 10px;
    border-radius: 4px;
  }
  .choose-path {
    line-height: 50px;
    padding: 0 10px;
    border-radius: 4px;
    border: solid 1px #dcdfe6;
    margin-top: 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  .template-list {
    border: solid 1px #dcdfe6;
    border-radius: 4px;
    margin-top: 20px;
    .list-box{
                height: 450px;
                overflow-y: auto;
            }
    .title {
      background: #f7f7f7;
    }
    .item {
      font-weight: bold;
      line-height: 52px;
      box-sizing: border-box;
      border-bottom: solid 1px #dcdfe6;
      padding: 0 10px;
      cursor: pointer;
      &:last-child {
        border: none;
      }
    }
  }
}
/deep/ .icon-arrow-back:before {
  font-size: 20px;
}
.lod-box {
  display: flex;
  align-items: center;
}
.back-box {
  margin-right: 10px;
  cursor: pointer;
}
.base_seting {
  overflow-y: auto;
  padding: 24px;
  max-width: 800px;
}
.delete-btn {
  position: absolute;
  margin-left: 10px;
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
  margin-bottom: 20px;
}
.column-box {
  .tree-box {
    max-height: 450px;
    overflow-y: auto;
    background: #f8f9fa;
  }
  /deep/.el-dialog__footer {
    padding-top: -5px;
  }
}
/deep/ .edui-default .edui-editor-toolbarbox {
  position: sticky;
  top: -10px;
  z-index: 9999;
}

/deep/ .edui-default .edui-editor-iframeholder,
.edui-default .edui-editor-iframeholder iframe {
  max-height: 220px;
  height: 220px;
}
/deep/ .ant-drawer-title {
  font-weight: 600;
  font-size: 18px;
}
/deep/.ant-form-item-label{
  width: 121px;
}
/deep/ .ant-form-item{
  display: flex;
}
/deep/ .ant-form-item-control-wrapper{
  width: 100%;
}
.btn-box{
    margin-top: 24px;
    margin-left: 102px;
}
.el-button--primary {
  background: #176de6;
}
.demo-ruleForm{
  overflow-y: auto;
}
.change-model{
  width: calc(100% - 110px);
}
  @media screen and (max-width: 720px) {
    .log-box{
      margin-left: 0px !important;
      margin-right: 0px !important;
      margin-top: 0px !important;
    }
    .form{
      width: 100% !important;
      margin-top: 20px;
    }
    .base_seting{
      padding: 0px !important;
      padding-right: 15px !important;
    }
    .demo-ruleForm{
      height: 50vh !important;
    }
    /deep/ .change-model{
      width: auto;
    }
    .choose_template .template-list .list-box{
      height: 45vh !important;
    }
    /deep/ .ant-form-item-label{
      width: 48%;
      text-align: center;
    }
  }
</style>
